export default __webpack_public_path__ + "static/media/OLI_WRD_4C_LTBG.95a4c075.png";